"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-11c53a08"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = ["href"];
const _hoisted_2 = {
    key: 0,
    class: "text-gray"
};
const _hoisted_3 = { class: "role-form-container" };
const _hoisted_4 = {
    class: "accordion role-details",
    open: ""
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header c-hand" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, [
            /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "詳細")
        ])
    ])
], -1 /* HOISTED */));
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* HOISTED */));
const _hoisted_7 = {
    class: "oplus-form-text",
    for: "role-name"
};
const _hoisted_8 = { class: "color-box-pos" };
const _hoisted_9 = { class: "role-form-color-text" };
const _hoisted_10 = {
    class: "oplus-form-text",
    for: "role-purpose"
};
const _hoisted_11 = { class: "form-padding" };
const _hoisted_12 = {
    class: "role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_13 = { class: "role-flex-child-wrap" };
const _hoisted_14 = {
    class: "oplus-form-text",
    for: "role-from"
};
const _hoisted_15 = ["value"];
const _hoisted_16 = {
    class: "oplus-form-text",
    for: "role-to"
};
const _hoisted_17 = ["value"];
const _hoisted_18 = {
    class: "oplus-form-text",
    for: "role-rest"
};
const _hoisted_19 = ["value"];
const _hoisted_20 = ["disabled"];
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "form-padding role-form-title accordion-header" }, "設定", -1 /* HOISTED */));
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider sub" }, null, -1 /* HOISTED */));
const _hoisted_23 = { class: "role-flex-child-wrap flex-column" };
const _hoisted_24 = { class: "role-setting-header" };
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "割り当て方法", -1 /* HOISTED */));
const _hoisted_26 = {
    key: 0,
    class: "pro-auto-lock tooltip",
    "data-tooltip": "この機能は、\n自動作成のアップグレード\nが必要となります。"
};
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "zmdi zmdi-lock zmdi-hc-lg" }, null, -1 /* HOISTED */));
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { class: "padding-top dropdown" };
const _hoisted_30 = {
    class: "shift-dropdown dropdown-toggle",
    tabindex: "0"
};
const _hoisted_31 = { class: "shift-dropdown-text" };
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("svg", { class: "svg-header-dimension-down-arrow" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("use", { "xlink:href": "/static/dashboard/oplus_custom_icons-1.svg#down-arrow-icon" })
], -1 /* HOISTED */));
const _hoisted_33 = { class: "shift-dropdown-menu menu" };
const _hoisted_34 = { class: "shift-select-items" };
const _hoisted_35 = { class: "role-flex-child-wrap flex-column" };
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "シフトの種類")
], -1 /* HOISTED */));
const _hoisted_37 = {
    class: "role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_38 = { class: "padding-top dropdown" };
const _hoisted_39 = {
    class: "shift-dropdown dropdown-toggle",
    tabindex: "0"
};
const _hoisted_40 = { class: "shift-dropdown-text" };
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("svg", { class: "svg-header-dimension-down-arrow" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("use", { "xlink:href": "/static/dashboard/oplus_custom_icons-1.svg#down-arrow-icon" })
], -1 /* HOISTED */));
const _hoisted_42 = { class: "shift-dropdown-menu menu" };
const _hoisted_43 = { class: "shift-select-items" };
const _hoisted_44 = ["onClick"];
const _hoisted_45 = { class: "role-flex-child-wrap flex-column" };
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "シフト表に表示(業務)")
], -1 /* HOISTED */));
const _hoisted_47 = {
    class: "padding-top role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_48 = { class: "flex-column" };
const _hoisted_49 = { class: "oplus-form-checkbox" };
const _hoisted_50 = { class: "oplus-form-checkbox" };
const _hoisted_51 = { class: "oplus-form-checkbox" };
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-setting-header" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "oplus-form-text" }, "その他")
], -1 /* HOISTED */));
const _hoisted_53 = {
    class: "padding-top role-flex-wrapper",
    "data-columns": "2"
};
const _hoisted_54 = { class: "flex-column" };
const _hoisted_55 = ["disabled"];
const _hoisted_56 = { class: "oplus-form-checkbox" };
const _hoisted_57 = { class: "oplus-form-checkbox" };
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "flex-start-align-center" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "夜勤"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("small", null, "(次の日にまたぐ)")
], -1 /* HOISTED */));
const _hoisted_59 = {
    class: "oplus-form-number",
    for: "role-modal-holiday-type"
};
const _hoisted_60 = { class: "flex-start-align-center" };
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "連携", -1 /* HOISTED */));
const _hoisted_62 = {
    key: 0,
    class: "circle-question tooltip",
    "data-tooltip": "この機能をご利用の場合は、\n設定画面にてKOTの連携設定を\n行ってください。"
};
const _hoisted_63 = {
    key: 1,
    class: "role-kot-pro pro-label small"
};
const _hoisted_64 = ["disabled"];
const _hoisted_65 = {
    class: "oplus-form-text",
    for: "role-modal-external-id"
};
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "連携用ID", -1 /* HOISTED */));
const _hoisted_67 = { class: "form-padding role-form-footer" };
const _hoisted_68 = {
    key: 1,
    class: "text-error"
};
const _hoisted_69 = { class: "accordion role-details" };
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header c-hand" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, "セクション")
    ])
], -1 /* HOISTED */));
const _hoisted_71 = { class: "accordion-body" };
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "role-form-title-divider" }, null, -1 /* HOISTED */));
const _hoisted_73 = { class: "form-padding" };
const _hoisted_74 = { class: "accordion role-details" };
const _hoisted_75 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header c-hand" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, "割り当て方法")
    ])
], -1 /* HOISTED */));
const _hoisted_76 = { class: "accordion-body" };
const _hoisted_77 = { class: "form-padding" };
const _hoisted_78 = { class: "accordion role-details" };
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("summary", { class: "accordion-header c-hand" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "d-flex flex-align-center flex-gap px-2" }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }),
        /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "role-form-title" }, "業務グループ")
    ])
], -1 /* HOISTED */));
const _hoisted_80 = { class: "accordion-body" };
const _hoisted_81 = { class: "form-padding" };
const ColorBox_vue_1 = __importDefault(require("../../vue/ColorBox.vue"));
const RolesTable_vue_1 = __importDefault(require("../../vue/RolesTable.vue"));
const models_js_1 = require("../../js/models.js");
const roles_js_1 = require("../../js/roles.js");
const common_1 = require("../../common/common");
const common_2 = require("../../js/common");
const slotTypesToString_1 = require("../../common/slotTypesToString");
const vue_3 = require("vue");
const OemSettingsText_1 = require("../../common/OemSettingsText");
const rolesStaffTableTypes_1 = require("../../vue/rolesStaffView/rolesStaffTableTypes");
const RoleRequiredWrapper_vue_1 = __importDefault(require("./RoleRequiredWrapper.vue"));
const SectionList_vue_1 = __importDefault(require("./SectionList.vue"));
const RoleRelationList_vue_1 = __importDefault(require("./RoleRelationList.vue"));
const AlertModal_vue_1 = __importDefault(require("../../vue/AlertModal.vue"));
const BreadCrumArrowIconSmall_vue_1 = __importDefault(require("../../assets/icons/BreadCrumArrowIconSmall.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RoleDataForm',
    props: {
        isGroupRoleForm: { type: Boolean },
        isGroupOwner: { type: Boolean },
        selectedOem: {},
        hasProPerm: { type: Boolean },
        hasAutoPerm: { type: Boolean },
        hasKot: { type: Boolean },
        hasRolePerm: { type: Boolean }
    },
    setup(__props) {
        const roleData = (0, vue_3.inject)("roleView");
        const activeUserData = (0, vue_3.inject)('activeUserData');
        const alertModal = (0, vue_3.ref)(null);
        const props = __props;
        const isColorBoxVisible = (0, vue_3.ref)(false);
        const isLoading = (0, vue_3.ref)(false);
        const selectedRoleID = (0, vue_3.ref)(0);
        const colorBoxEl = (0, vue_3.ref)(null);
        const editSharedSettings = props.isGroupRoleForm && props.isGroupOwner;
        const formData = (0, vue_3.ref)({
            id: 0,
            name: "",
            purpose: "",
            from: "",
            to: "",
            rest: "",
            wage: "",
            isNightShift: false,
            nextDayOff: false,
            showCount: true,
            showStaffCount: true,
            color: models_js_1.OPLUS_COLOR_PALETTE.DEFAULT,
            type: rolesStaffTableTypes_1.ROLE_TYPE_INDEX.BY_DAYS,
            slotType: models_js_1.SLOT_TYPES.HOURLY,
            kotHolidayType: "",
            externalID: "",
            isHiddenInShiftPage: false,
            isDisabledWhenFull: false,
            isGroupWide: props.isGroupRoleForm, // always set to true if we are on group-role page
        });
        function setFormData() {
            const role = roleData?.value;
            if (!role) {
                return;
            }
            formData.value.name = role.name;
            formData.value.purpose = role.purpose;
            formData.value.from = role.from;
            formData.value.to = role.to;
            formData.value.rest = role.rest;
            formData.value.wage = role.wage;
            formData.value.isNightShift = role.isNightShift;
            formData.value.nextDayOff = role.nextDayOff;
            formData.value.showCount = role.showCount;
            formData.value.showStaffCount = role.showStaffCount;
            formData.value.color = role.color ? role.color : models_js_1.OPLUS_COLOR_PALETTE.DEFAULT;
            formData.value.type = role.type;
            formData.value.slotType = role.slotType;
            formData.value.kotHolidayType = role.kotHolidayType;
            formData.value.externalID = role.externalID;
            formData.value.isHiddenInShiftPage = role.isHiddenInShiftPage;
            formData.value.isDisabledWhenFull = role.isDisabledWhenFull;
            formData.value.isGroupWide = role.isGroupWide;
            selectedRoleID.value = role.id;
        }
        function openColorBox() {
            isColorBoxVisible.value = true;
        }
        // Close color box outside click
        function handleRoleContainerClick(event) {
            const target = event.target;
            if (!colorBoxEl.value?.contains(target)) {
                isColorBoxVisible.value = false;
            }
            return;
        }
        function computedRoleTime(value) {
            if (value.length === 3) {
                value = `0${value}`;
            }
            const { hour, min } = (0, common_1.extractTimeAndMin)(value, false);
            if (hour === undefined && min === undefined) {
                return "";
            }
            return `${(0, common_2.addZeroPlaceholders)(hour)}:${(0, common_2.addZeroPlaceholders)(min)}`;
        }
        function handleFromShiftInput(event) {
            const target = event.target;
            const value = target.value;
            formData.value.from = computedRoleTime(value);
        }
        function handleToShiftInput(event) {
            const target = event.target;
            const value = target.value;
            formData.value.to = computedRoleTime(value);
        }
        function handleRestShiftInput(event) {
            const target = event.target;
            const value = target.value;
            formData.value.rest = computedRoleTime(value);
        }
        // emit handler from Colorbox component
        function setSelectedColor(colorStr) {
            return formData.value.color = colorStr;
        }
        // We pass empty string to the request if its a default color
        function setColorDataForSubmit() {
            if (formData.value.color === models_js_1.OPLUS_COLOR_PALETTE.DEFAULT) {
                return "none";
            }
            else {
                return formData.value.color;
            }
        }
        async function handleSubmit() {
            if (isLoading.value) {
                return;
            }
            if (!formData.value?.name) {
                return;
            }
            isLoading.value = true;
            if (formData.value.type === 1) {
                formData.value.isDisabledWhenFull = false;
            }
            if (formData.value.from) {
                formData.value.from = computedRoleTime(formData.value.from.trim());
            }
            if (formData.value.to) {
                formData.value.to = computedRoleTime(formData.value.to.trim());
            }
            formData.value.color = setColorDataForSubmit();
            let payload = {};
            if (!selectedRoleID.value) {
                return;
            }
            if (!isRoleFormDisableInBranchPage.value) {
                payload = {
                    ...formData.value,
                    editSharedSettings,
                };
            }
            else {
                payload = {
                    from: formData.value.from,
                    to: formData.value.to
                };
            }
            try {
                await (0, roles_js_1.putAndUpdateSharedRoleData)(selectedRoleID.value, payload);
                alertModal.value?.alertSuccess("業務を編集しました。");
            }
            catch (err) {
                alertModal.value?.alert("fail to update role");
            }
            isLoading.value = false;
        }
        function disabledClass(hasPerm) {
            return hasPerm ? "" : "disabled-btn";
        }
        function handleSlotTypeClick(slotType) {
            formData.value.slotType = slotType;
        }
        function handleRoleTypeClick(roleType) {
            formData.value.type = roleType;
        }
        const submitButtonText = (0, vue_3.computed)(() => {
            return selectedRoleID.value ? "編集" : "作成";
        });
        const loadingClass = (0, vue_3.computed)(() => {
            return isLoading.value ? "loading" : "";
        });
        const selectedColorBox = (0, vue_3.computed)(() => {
            return formData.value.color;
        });
        const colorBoxStyle = (0, vue_3.computed)(() => {
            return {
                backgroundColor: `#${selectedColorBox.value}`,
                borderColor: `#${selectedColorBox.value}`,
            };
        });
        const disableRoleFormInGroupPage = (0, vue_3.computed)(() => {
            return Boolean(selectedRoleID.value && !props.isGroupOwner && roleData?.value?.isGroupWide && props.isGroupRoleForm);
        });
        const isRoleFormDisableInBranchPage = (0, vue_3.computed)(() => {
            return Boolean(selectedRoleID.value && roleData?.value?.isGroupWide && !props.isGroupRoleForm);
        });
        const disableRoleFormInBranchPage = (0, vue_3.computed)(() => {
            return isRoleFormDisableInBranchPage.value ? 'disabled-btn' : '';
        });
        const disableTheDisabledWhenFullOption = (0, vue_3.computed)(() => {
            return formData.value.type === 1;
        });
        const optionDisabledClass = (0, vue_3.computed)(() => {
            return {
                disabled: formData.value.type === 1,
            };
        });
        const slotTypes = Object.entries(slotTypesToString_1.slotTypeString);
        const computedActiveUserData = (0, vue_3.computed)(() => {
            return activeUserData || { userId: 0, branchId: 0 };
        });
        const thisRoleStyle = (0, vue_3.computed)(() => {
            return { color: `#${roleData?.value?.color ? roleData.value.color : '8a8a8a'}` };
        });
        const roleName = (0, vue_3.computed)(() => {
            return roleData?.value?.name || "";
        });
        const isNightShift = (0, vue_3.computed)(() => {
            return roleData?.value?.isNightShift || false;
        });
        (0, vue_3.onMounted)(() => {
            setFormData();
        });
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (0, vue_2.createVNode)(AlertModal_vue_1.default, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512 /* NEED_PATCH */),
                (0, vue_2.createElementVNode)("a", {
                    class: "page-title-text d-flex",
                    href: `/dashboard/${computedActiveUserData.value.userId}/roles?c=${computedActiveUserData.value.branchId}`
                }, [
                    (0, vue_2.createTextVNode)("業務管理 "),
                    (0, vue_2.createVNode)(BreadCrumArrowIconSmall_vue_1.default),
                    (0, vue_2.createElementVNode)("span", {
                        style: (0, vue_2.normalizeStyle)(thisRoleStyle.value)
                    }, [
                        (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(roleName.value), 1 /* TEXT */),
                        (isNightShift.value)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, "(夜勤)"))
                            : (0, vue_2.createCommentVNode)("v-if", true)
                    ], 4 /* STYLE */)
                ], 8 /* PROPS */, _hoisted_1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createVNode)(RolesTable_vue_1.default, {
                        roles: [formData.value],
                        "is-group-role-form": _ctx.isGroupRoleForm,
                        "use-for-create-or-edit": true
                    }, null, 8 /* PROPS */, ["roles", "is-group-role-form"]),
                    (0, vue_2.createElementVNode)("details", _hoisted_4, [
                        _hoisted_5,
                        (0, vue_2.createElementVNode)("form", {
                            onSubmit: (0, vue_2.withModifiers)(handleSubmit, ["prevent"]),
                            onClick: handleRoleContainerClick
                        }, [
                            (0, vue_2.createElementVNode)("div", {
                                class: (0, vue_2.normalizeClass)(["accordion-body", { 'disabled-btn': disableRoleFormInGroupPage.value }])
                            }, [
                                _hoisted_6,
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding relative", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_7, [
                                        (0, vue_2.createTextVNode)("ラベル (必須) "),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formData.value.name) = $event)),
                                            type: "text",
                                            name: "role-name",
                                            id: "",
                                            placeholder: "業務名"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, formData.value.name]
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                        (0, vue_2.createElementVNode)("div", {
                                            ref_key: "colorBoxEl",
                                            ref: colorBoxEl,
                                            class: "role-form-color-wrapper",
                                            onClick: openColorBox
                                        }, [
                                            (0, vue_2.createElementVNode)("div", {
                                                class: "role-form-color-box",
                                                style: (0, vue_2.normalizeStyle)(colorBoxStyle.value)
                                            }, null, 4 /* STYLE */),
                                            (0, vue_2.createElementVNode)("span", _hoisted_9, [
                                                (0, vue_2.createTextVNode)("色塗り "),
                                                (0, vue_2.createVNode)(vue_2.Transition, { name: "slide-up" }, {
                                                    default: (0, vue_2.withCtx)(() => [
                                                        (0, vue_2.createVNode)(ColorBox_vue_1.default, {
                                                            class: "oplus-color-box",
                                                            "selected-color": selectedColorBox.value,
                                                            "is-visible": isColorBoxVisible.value,
                                                            onColorSelect: setSelectedColor
                                                        }, null, 8 /* PROPS */, ["selected-color", "is-visible"])
                                                    ]),
                                                    _: 1 /* STABLE */
                                                })
                                            ])
                                        ], 512 /* NEED_PATCH */)
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("label", _hoisted_10, [
                                        (0, vue_2.createTextVNode)(" 説明 "),
                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((formData.value.purpose) = $event)),
                                            type: "text",
                                            name: "role-purpose",
                                            placeholder: "朝番, レジ"
                                        }, null, 512 /* NEED_PATCH */), [
                                            [vue_2.vModelText, formData.value.purpose]
                                        ])
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", _hoisted_11, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_14, [
                                                    (0, vue_2.createTextVNode)(" から "),
                                                    (0, vue_2.createElementVNode)("input", {
                                                        value: formData.value.from,
                                                        onChange: handleFromShiftInput,
                                                        type: "text",
                                                        name: "role-from",
                                                        id: "",
                                                        placeholder: "10, 10:00, 1000"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_15)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_16, [
                                                    (0, vue_2.createTextVNode)(" まで "),
                                                    (0, vue_2.createElementVNode)("input", {
                                                        value: formData.value.to,
                                                        onChange: handleToShiftInput,
                                                        type: "text",
                                                        name: "role-to",
                                                        id: "",
                                                        placeholder: "18, 18:00, 1800"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_17)
                                                ])
                                            ])
                                        ]),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: (0, vue_2.normalizeClass)(["role-flex-child-wrap", disableRoleFormInBranchPage.value])
                                        }, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_18, [
                                                    (0, vue_2.createTextVNode)(" 休憩時間 "),
                                                    (0, vue_2.createElementVNode)("input", {
                                                        value: formData.value.rest,
                                                        onChange: handleRestShiftInput,
                                                        type: "text",
                                                        name: "role-rest",
                                                        id: "",
                                                        placeholder: "1, 1:30"
                                                    }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_19)
                                                ])
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("label", {
                                                    class: (0, vue_2.normalizeClass)(["oplus-form-number", disabledClass(_ctx.hasRolePerm)]),
                                                    for: "role-wage"
                                                }, [
                                                    (0, vue_2.createTextVNode)(" 時給 "),
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((formData.value.wage) = $event)),
                                                        type: "number",
                                                        name: "role-wage",
                                                        id: "",
                                                        placeholder: "1000",
                                                        disabled: !_ctx.hasRolePerm
                                                    }, null, 8 /* PROPS */, _hoisted_20), [
                                                        [vue_2.vModelText, formData.value.wage]
                                                    ])
                                                ], 2 /* CLASS */)
                                            ])
                                        ], 2 /* CLASS */)
                                    ])
                                ]),
                                _hoisted_21,
                                _hoisted_22,
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding role-flex-wrapper", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_23, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                            _hoisted_25,
                                            (!_ctx.hasAutoPerm)
                                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_26, _hoisted_28))
                                                : (0, vue_2.createCommentVNode)("v-if", true)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", {
                                            class: (0, vue_2.normalizeClass)(["role-flex-wrapper", disabledClass(_ctx.hasAutoPerm)]),
                                            "data-columns": "2"
                                        }, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(rolesStaffTableTypes_1.ROLE_TYPE_TEXT)[formData.value.type || 0]), 1 /* TEXT */),
                                                    _hoisted_32
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_34, [
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: "shift-select-dropdown-item",
                                                            onClick: _cache[3] || (_cache[3] = ($event) => (handleRoleTypeClick(0)))
                                                        }, "曜日別"),
                                                        (0, vue_2.createElementVNode)("span", {
                                                            class: "shift-select-dropdown-item",
                                                            onClick: _cache[4] || (_cache[4] = ($event) => (handleRoleTypeClick(1)))
                                                        }, "スタッフごと")
                                                    ])
                                                ])
                                            ])
                                        ], 2 /* CLASS */)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_35, [
                                        _hoisted_36,
                                        (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_38, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                                    (0, vue_2.createElementVNode)("span", _hoisted_40, (0, vue_2.toDisplayString)((0, vue_2.unref)(slotTypesToString_1.slotTypeString)[formData.value.slotType || 0]), 1 /* TEXT */),
                                                    _hoisted_41
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                                        ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(slotTypes), (slotType) => {
                                                            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", {
                                                                class: "shift-select-dropdown-item",
                                                                onClick: ($event) => (handleSlotTypeClick(parseInt(slotType[0])))
                                                            }, (0, vue_2.toDisplayString)(slotType[1]), 9 /* TEXT, PROPS */, _hoisted_44));
                                                        }), 256 /* UNKEYED_FRAGMENT */))
                                                    ])
                                                ])
                                            ])
                                        ])
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["form-padding role-flex-wrapper", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_45, [
                                        _hoisted_46,
                                        (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_48, [
                                                (0, vue_2.createElementVNode)("label", _hoisted_49, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((formData.value.showCount) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-show-count"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.showCount]
                                                    ]),
                                                    (0, vue_2.createTextVNode)(" カウント ")
                                                ]),
                                                (0, vue_2.createElementVNode)("label", _hoisted_50, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((formData.value.showStaffCount) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-show-staff-count"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.showStaffCount]
                                                    ]),
                                                    (0, vue_2.createTextVNode)(" 割当 ")
                                                ]),
                                                (0, vue_2.createElementVNode)("label", _hoisted_51, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((formData.value.isHiddenInShiftPage) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-hidden-in-shift-page"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.isHiddenInShiftPage]
                                                    ]),
                                                    (0, vue_2.createTextVNode)(" シフト提出ページに非表示 ")
                                                ])
                                            ])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", {
                                        class: (0, vue_2.normalizeClass)(["role-flex-child-wrap flex-column", disableRoleFormInBranchPage.value])
                                    }, [
                                        _hoisted_52,
                                        (0, vue_2.createElementVNode)("div", _hoisted_53, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_54, [
                                                (_ctx.isGroupRoleForm)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("label", {
                                                        key: 0,
                                                        class: (0, vue_2.normalizeClass)(["oplus-form-checkbox", { 'disabled-btn': Boolean(_ctx.isGroupRoleForm || selectedRoleID.value) }])
                                                    }, [
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((formData.value.isGroupWide) = $event)),
                                                            type: "checkbox",
                                                            id: "role-modal-groupwide"
                                                        }, null, 512 /* NEED_PATCH */), [
                                                            [vue_2.vModelCheckbox, formData.value.isGroupWide]
                                                        ]),
                                                        (0, vue_2.createTextVNode)(" 他拠点へ同期 ")
                                                    ], 2 /* CLASS */))
                                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                                (0, vue_2.createElementVNode)("label", {
                                                    class: (0, vue_2.normalizeClass)(["oplus-form-checkbox", optionDisabledClass.value])
                                                }, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((formData.value.isDisabledWhenFull) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-disabled-when-full",
                                                        disabled: disableTheDisabledWhenFullOption.value
                                                    }, null, 8 /* PROPS */, _hoisted_55), [
                                                        [vue_2.vModelCheckbox, formData.value.isDisabledWhenFull]
                                                    ]),
                                                    (0, vue_2.createTextVNode)(" 必要人数を満たしている場合無効 ")
                                                ], 2 /* CLASS */),
                                                (0, vue_2.createElementVNode)("label", _hoisted_56, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((formData.value.nextDayOff) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-nextdayoff"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.nextDayOff]
                                                    ]),
                                                    (0, vue_2.createTextVNode)(" 次の日休み ")
                                                ]),
                                                (0, vue_2.createElementVNode)("label", _hoisted_57, [
                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event) => ((formData.value.isNightShift) = $event)),
                                                        type: "checkbox",
                                                        id: "role-modal-isnightshift"
                                                    }, null, 512 /* NEED_PATCH */), [
                                                        [vue_2.vModelCheckbox, formData.value.isNightShift]
                                                    ]),
                                                    _hoisted_58
                                                ])
                                            ])
                                        ])
                                    ], 2 /* CLASS */)
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", {
                                    class: (0, vue_2.normalizeClass)(["role-flex-wrapper form-padding", disableRoleFormInBranchPage.value])
                                }, [
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("label", _hoisted_59, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_60, [
                                                (0, vue_2.createElementVNode)("span", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(OemSettingsText_1.selectedOemText)[props?.selectedOem || 0]), 1 /* TEXT */),
                                                _hoisted_61,
                                                (!_ctx.hasKot && _ctx.hasProPerm)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_62))
                                                    : (0, vue_2.createCommentVNode)("v-if", true),
                                                (!_ctx.hasProPerm)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_63))
                                                    : (0, vue_2.createCommentVNode)("v-if", true)
                                            ]),
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((formData.value.kotHolidayType) = $event)),
                                                id: "role-modal-holiday-type",
                                                type: "number",
                                                placeholder: "休暇区分コード",
                                                disabled: !_ctx.hasKot
                                            }, null, 8 /* PROPS */, _hoisted_64), [
                                                [vue_2.vModelText, formData.value.kotHolidayType]
                                            ])
                                        ])
                                    ]),
                                    (0, vue_2.createElementVNode)("div", null, [
                                        (0, vue_2.createElementVNode)("label", _hoisted_65, [
                                            _hoisted_66,
                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event) => ((formData.value.externalID) = $event)),
                                                type: "text",
                                                id: "role-modal-external-id",
                                                placeholder: "101"
                                            }, null, 512 /* NEED_PATCH */), [
                                                [vue_2.vModelText, formData.value.externalID]
                                            ])
                                        ])
                                    ])
                                ], 2 /* CLASS */),
                                (0, vue_2.createElementVNode)("div", _hoisted_67, [
                                    (!disableRoleFormInGroupPage.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                            key: 0,
                                            class: (0, vue_2.normalizeClass)([loadingClass.value, "oplus-modal-btn oplus-confirm-btn"])
                                        }, (0, vue_2.toDisplayString)(submitButtonText.value), 3 /* TEXT, CLASS */))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("small", _hoisted_68, "オーナーのみ設定を編集できます"))
                                ])
                            ], 2 /* CLASS */)
                        ], 32 /* NEED_HYDRATION */)
                    ]),
                    (0, vue_2.createElementVNode)("details", _hoisted_69, [
                        _hoisted_70,
                        (0, vue_2.createElementVNode)("div", _hoisted_71, [
                            _hoisted_72,
                            (0, vue_2.createElementVNode)("div", _hoisted_73, [
                                (0, vue_2.createVNode)(SectionList_vue_1.default)
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("details", _hoisted_74, [
                        _hoisted_75,
                        (0, vue_2.createElementVNode)("div", _hoisted_76, [
                            (0, vue_2.createElementVNode)("div", _hoisted_77, [
                                (0, vue_2.createVNode)(RoleRequiredWrapper_vue_1.default, { "has-auto-perm": _ctx.hasAutoPerm }, null, 8 /* PROPS */, ["has-auto-perm"])
                            ])
                        ])
                    ]),
                    (0, vue_2.createElementVNode)("details", _hoisted_78, [
                        _hoisted_79,
                        (0, vue_2.createElementVNode)("div", _hoisted_80, [
                            (0, vue_2.createElementVNode)("div", _hoisted_81, [
                                (0, vue_2.createVNode)(RoleRelationList_vue_1.default)
                            ])
                        ])
                    ])
                ])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
